import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, X } from "lucide-react";

const DISMISS_KEY = "terra_borgo_banner_v1";

/**
 * Invito ad impostare il borgo/paese d'appartenenza per utenti registrati
 * che non hanno ancora un'affiliazione territoriale (tipico: account Google).
 * Visibile solo su /piazze* e /profilo; dismiss persistente in localStorage.
 */
export default function BorgoOnboardingBanner({ user, pathname }) {
  const [dismissed, setDismissed] = useState(() => {
    try { return window.localStorage.getItem(DISMISS_KEY) === "1"; } catch { return false; }
  });
  const [show, setShow] = useState(false);

  const onPiazzaRoute =
    pathname.startsWith("/piazze") || pathname === "/profilo";
  const needsAffiliation = !!user && !user.comune_slug && !user.country_name;
  const visible = onPiazzaRoute && needsAffiliation && !dismissed;

  useEffect(() => {
    if (!visible) { setShow(false); return undefined; }
    const t = window.setTimeout(() => setShow(true), 400);
    return () => window.clearTimeout(t);
  }, [visible]);

  if (!visible && !show) return null;

  const dismiss = () => {
    setDismissed(true);
    try { window.localStorage.setItem(DISMISS_KEY, "1"); } catch { /* noop */ }
  };

  return (
    <div
      className={`borgo-onboarding ${show ? "borgo-onboarding--visible" : ""}`}
      role="dialog"
      aria-live="polite"
      data-testid="borgo-onboarding"
    >
      <MapPin size={15} className="borgo-onboarding__icon" aria-hidden />
      <p className="borgo-onboarding__text">
        Di dove sei? Imposta il tuo borgo o paese
      </p>
      <Link to="/profilo?setup=borgo" className="borgo-onboarding__cta" onClick={dismiss}>
        Scegli
      </Link>
      <button
        type="button"
        className="borgo-onboarding__close"
        onClick={dismiss}
        aria-label="Chiudi"
      >
        <X size={14} />
      </button>
    </div>
  );
}
